module.exports = __webpack_public_path__ + "img/bottle_arcane.be5acdbc.png";